import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { intlMessageShape } from 'sb-react-intl'


export default (WrappedComponent) =>

  class SelectizeState extends Component {

    static propTypes = {
      className: PropTypes.string,
      inputId: PropTypes.string,
      optionsId: PropTypes.string,
      options: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.shape(intlMessageShape),
        ]),
        value: PropTypes.string,
      })),
      value: PropTypes.string, // option value
      inputValue: PropTypes.string, // input value
      placeholder: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape(intlMessageShape),
      ]),
      onChange: PropTypes.func,
      onSelect: PropTypes.func,
    }

    static childContextTypes = {
      selectize: PropTypes.object,
    }

    static defaultProps = {
      options: [],
    }

    getChildContext() {

      return {
        selectize: {
          subscribeOnChange: this.subscribeOnChange,
          onChange: this.handleChange,
          onSelect: this.handleSelect,
        },
      }
    }

    constructor({ options, value, inputValue }) {
      super()

      // initial values required for componentWillReceiveProps to check if value changed programmatically outside of component
      this.initialValue = value
      this.initialInputValue = inputValue

      this.state = {
        inputValue: value && this.getTitleByValue(options, value) || inputValue || '',
      }
    }

    // if new selected value passed to component, then need to change input value (inputValue)
    UNSAFE_componentWillReceiveProps(nextProps) {
      const { initialValue, initialInputValue } = this
      const { value, inputValue } = nextProps // default empty line need in case currentValue = '' and newValue = undefined

      if (value !== initialValue) {
        const { options } = this.props
        const inputValue = this.getTitleByValue(options, value)

        this.setState({
          inputValue,
        })
      }
      else if (inputValue !== initialInputValue) {
        this.setState({
          inputValue: initialInputValue || '',
        })
      }
    }

    getTitleByValue = (options, value) => {
      const { title = '' } = options.find((option) => option.value === value) || {}

      return title
    }

    subscribeOnChange = (cb) => {
      this.onChangeCallback = cb
    }

    handleChange = (inputValue) => {
      const { onChange } = this.props

      this.setState({
        inputValue,
      })

      if (typeof onChange === 'function') {
        onChange(inputValue)
      }

      if (typeof this.onChangeCallback === 'function') {
        this.onChangeCallback(inputValue)
      }
    }

    handleSelect = (option) => {
      const { onSelect } = this.props
      const { title } = option

      this.setState({
        inputValue: title,
      })

      if (typeof onSelect === 'function') {
        onSelect(option)
      }
    }

    render() {

      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
        />
      )
    }
  }
